const GET_CALCULATION_RULE_LIST_REQUESTED = 'brand/GET_CALCULATION_RULE_LIST_REQUESTED';
const GET_CALCULATION_RULE_LIST_SUCCESS = 'brand/GET_CALCULATION_RULE_LIST_SUCCESS';
const GET_CALCULATION_RULE_LIST_FAILURE = 'brand/GET_CALCULATION_RULE_LIST_FAILURE';

const GET_CALCULATION_RULE_BY_ID_REQUESTED = 'brand/GET_CALCULATION_RULE_BY_ID_REQUESTED';
const GET_CALCULATION_RULE_BY_ID_SUCCESS = 'brand/GET_CALCULATION_RULE_BY_ID_SUCCESS';
const GET_CALCULATION_RULE_BY_ID_FAILURE = 'brand/GET_CALCULATION_RULE_BY_ID_FAILURE';

const ADD_CALCULATION_RULE_REQUESTED = 'brand/ADD_CALCULATION_RULE_REQUESTED';
const ADD_CALCULATION_RULE_SUCCESS = 'brand/ADD_CALCULATION_RULE_SUCCESS';
const ADD_CALCULATION_RULE_FAILURE = 'brand/ADD_CALCULATION_RULE_FAILURE';

const UPDATE_CALCULATION_RULE_REQUESTED = 'brand/UPDATE_CALCULATION_RULE_REQUESTED';
const UPDATE_CALCULATION_RULE_SUCCESS = 'brand/UPDATE_CALCULATION_RULE_SUCCESS';
const UPDATE_CALCULATION_RULE_FAILURE = 'brand/UPDATE_CALCULATION_RULE_FAILURE';

const DELETE_CALCULATION_RULE_REQUESTED = 'brand/DELETE_CALCULATION_RULE_REQUESTED';
const DELETE_CALCULATION_RULE_SUCCESS = 'brand/DELETE_CALCULATION_RULE_SUCCESS';
const DELETE_CALCULATION_RULE_FAILURE = 'brand/DELETE_CALCULATION_RULE_FAILURE';

const GET_DENOMINATION_TYPES_REQUESTED = 'brand/GET_DENOMINATION_TYPES_REQUESTED';
const GET_DENOMINATION_TYPES_SUCCESS = 'brand/GET_DENOMINATION_TYPES_SUCCESS';
const GET_DENOMINATION_TYPES_FAILURE = 'brand/GET_DENOMINATION_TYPES_FAILURE';

const GET_ROUNDING_TYPES_REQUESTED = 'brand/GET_ROUNDING_TYPES_REQUESTED';
const GET_ROUNDING_TYPES_SUCCESS = 'brand/GET_ROUNDING_TYPES_SUCCESS';
const GET_ROUNDING_TYPES_FAILURE = 'brand/GET_ROUNDING_TYPES_FAILURE';

const RESET_CALCULATION_RULE_DATA = 'brand/RESET_CALCULATION_RULE_DATA';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  calculationRuleList: [],
  calculationRuleData: null,
  denominationTypes: [],
  roundingTypes: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_CALCULATION_RULE_LIST_REQUESTED:
    case GET_CALCULATION_RULE_BY_ID_REQUESTED:
    case ADD_CALCULATION_RULE_REQUESTED:
    case UPDATE_CALCULATION_RULE_REQUESTED:
    case DELETE_CALCULATION_RULE_REQUESTED:
    case GET_DENOMINATION_TYPES_REQUESTED:
    case GET_ROUNDING_TYPES_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case GET_CALCULATION_RULE_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        calculationRuleList: action.result,
      };
    }
    case GET_CALCULATION_RULE_BY_ID_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        calculationRuleData: action.result,
      };
    }
    case GET_DENOMINATION_TYPES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        denominationTypes: action.result,
      };
    }
    case GET_ROUNDING_TYPES_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        roundingTypes: action.result,
      };
    }
    case ADD_CALCULATION_RULE_SUCCESS:
    case UPDATE_CALCULATION_RULE_SUCCESS:
    case DELETE_CALCULATION_RULE_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
      };
    }
    case GET_CALCULATION_RULE_LIST_FAILURE:
    case GET_CALCULATION_RULE_BY_ID_FAILURE:
    case ADD_CALCULATION_RULE_FAILURE:
    case UPDATE_CALCULATION_RULE_FAILURE:
    case DELETE_CALCULATION_RULE_FAILURE:
    case GET_DENOMINATION_TYPES_FAILURE:
    case GET_ROUNDING_TYPES_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true,
      };
    }
    case RESET_CALCULATION_RULE_DATA: {
      return {
        ...state,
        calculationRuleData: null,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
};

export const getCalculationRuleList = brandId => ({
  types: [GET_CALCULATION_RULE_LIST_REQUESTED, GET_CALCULATION_RULE_LIST_SUCCESS, GET_CALCULATION_RULE_LIST_FAILURE],
  promise: client => client.get(`getBrandCashRoundingList/${brandId}`),
});

export const getCalculationRuleById = brandCashRoundingId => ({
  types: [GET_CALCULATION_RULE_BY_ID_REQUESTED, GET_CALCULATION_RULE_BY_ID_SUCCESS, GET_CALCULATION_RULE_BY_ID_FAILURE],
  promise: client => client.get(`getBrandCashRoundingById/${brandCashRoundingId}`),
});

export const addCalculationRule = data => ({
  types: [ADD_CALCULATION_RULE_REQUESTED, ADD_CALCULATION_RULE_SUCCESS, ADD_CALCULATION_RULE_FAILURE],
  promise: client => client.post('addBrandCashRounding', { data }),
});

export const updateCalculationRule = data => ({
  types: [UPDATE_CALCULATION_RULE_REQUESTED, UPDATE_CALCULATION_RULE_SUCCESS, UPDATE_CALCULATION_RULE_FAILURE],
  promise: client => client.post('updateBrandCashRounding', { data }),
});

export const deleteCalculationRule = brandCashRoundingId => ({
  types: [DELETE_CALCULATION_RULE_REQUESTED, DELETE_CALCULATION_RULE_SUCCESS, DELETE_CALCULATION_RULE_FAILURE],
  promise: client => client.post(`deleteBrandCashRounding/${brandCashRoundingId}`),
});

export const getDenominationTypes = () => ({
  types: [GET_DENOMINATION_TYPES_REQUESTED, GET_DENOMINATION_TYPES_SUCCESS, GET_DENOMINATION_TYPES_FAILURE],
  promise: client => client.get('getBrandCashDenominationTypes'),
});

export const getRoundingTypes = () => ({
  types: [GET_ROUNDING_TYPES_REQUESTED, GET_ROUNDING_TYPES_SUCCESS, GET_ROUNDING_TYPES_FAILURE],
  promise: client => client.get('getBrandCashRoundingTypes'),
});

export const resetCalculationRuleData = () => ({ type: RESET_CALCULATION_RULE_DATA });
